import { getKeys } from './getKeys'

export const emarV2Translations = {
  STOCK_MEDICATION_NAME: 'Stock - {{medicationName}}',
  STOCK: 'Stock',
  MANAGE_STOCK: 'Manage Stock',
  STOCK_CHECK: 'Stock Check',
  EDIT_STOCK_CHECK: 'Edit Stock Check',
  NEW_DELIVERY_RECEIVED: 'New Delivery Received',
  DELIVERY: 'Delivery',
  EDIT_DELIVERY: 'Edit Delivery',
  DISPOSAL: 'Disposal',
  EDIT_DISPOSAL: 'Edit Disposal',
  READ_MORE: 'Read more',
  DOWNLOAD_PDF: 'Download PDF',
  VIEW_RECORD: 'View record',
  EDIT_RECORD: 'Edit record',
  EDIT: 'Edit',
  LOW_STOCK_ALERT: 'The stock levels for this medication are low.',
  DATE_RANGE: 'Date Range',
  STOCK_LEVEL_CHART: 'Stock Level Chart',
  STOCK_COUNT_HISTORY: 'Stock Count History',
  TIME_RECORDED: 'Time recorded',
  RECORDED_BY: 'Recorded by',
  ACTION: 'Action',
  EXPECTED_STOCK: 'Expected Stock',
  EXPECTED_STOCK_TOOLTIP:
    "The system's estimated count, automatically updated based on administration, disposals, and deliveries.",
  STOCK_COUNT: 'Stock Count',
  STOCK_COUNT_TOOLTIP:
    'The actual count entered by team members during a stock check.',
  DATE: 'Date',
  STOCK_COUNT_UNIT: 'Stock Count ({{unit}})',
  DESCRIPTION: 'Description',
  DESCRIPTION_REQUIRED: 'Please enter a description',
  DESCRIPTION_MAX_LENGTH: 'Description must not exceed 150 characters',
  ENTER_DESCRIPTION: 'Enter description...',
  ENTER_STOCK_ADJUSTMENT: 'Enter stock adjustment',
  SET_STOCK_COUNT: 'Set stock count',
  DISCREPANCY: 'Discrepancy',
  ADJUSTMENT: 'Adjustment (+/-)',
  NEW_STOCK: 'New Stock',
  TABLETS: 'tablets',
  EXPECTED_STOCK_ACCURATE: 'Expected stock count is accurate',
  ADDITIONAL_DETAILS: 'Additional Details',
  MEDIA: 'Media',
  CLICK_TO_UPLOAD: 'Click to Upload',
  ADJUSTMENT_TOO_HIGH:
    'The value to be deducted is higher than Expected Stock.',
  DISCREPANCY_DETECTED: 'Stock count differs from expected stock count.',
  RESOLVED: 'Resolved',
  DISCREPANCY_RESOLVED: 'Discrepancy has been resolved',
  RESOLVE_DISCREPANCY: 'Resolve Discrepancy?',
  RESOLVE_DISCREPANCY_REQUIRED:
    'Please select whether to resolve the discrepancy',
  NO_LEAVE_OPEN: 'No (Discrepancy is left open in reports)',
  YES_MARKED_RESOLVED: 'Yes (Marked as resolved in reports)',
  REASON_FOR_DISCREPANCY: 'Reason for discrepancy',
  REASON_FOR_DISCREPANCY_REQUIRED: 'Please enter a reason for the discrepancy',
  ENTER_REASON: 'Enter reason...',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  CURRENT_STOCK_ACCURATE: 'Current stock count is accurate',
  RECEIVED_STOCK: 'Received Stock',
  RECEIVED_BY: 'Received by',
  RECEIVED_BY_REQUIRED: 'Please select who received the delivery',
  RECEIVE_DATE: 'Receive date',
  RECEIVE_DATE_REQUIRED: 'Please select a date',
  RECEIVED_FROM: 'Received from',
  RECEIVED_FROM_REQUIRED: 'Please enter where the delivery was received from',
  RECEIVED_FROM_TOOLTIP:
    'Enter where you received your medications. For example, enter the name of a pharmacy or a family member.',
  SELECT_DATE: 'Select date',
  SELECT_PERSON: 'Please select',
  TYPE_HERE: 'Type here...',
  WITNESSED_BY: 'Witnessed by',
  WITNESSED_BY_REQUIRED: 'Please select a witness',
  WITNESS_PIN: 'Witness PIN',
  WITNESS_PIN_REQUIRED: 'Please enter witness PIN',
  INVALID_INPUT: 'Please enter a number greater than 0',
  DISPOSED_STOCK: 'Disposed Stock',
  DISPOSAL_TOO_HIGH: 'The disposed amount is higher than Expected Stock.',
  ACTIONED_BY: 'Actioned by',
  ACTIONED_BY_REQUIRED: 'Please select who actioned the disposal',
  ACTIONED_DATE: 'Actioned date',
  ACTIONED_DATE_REQUIRED: 'Please select a date',
  DISPOSAL_METHOD: 'Disposal method',
  DISPOSAL_METHOD_REQUIRED: 'Please enter the disposal method',
  DISPOSAL_METHOD_TOOLTIP:
    'Enter how the medication was disposed of. For example, enter "Returned to pharmacy", "Destroyed", or "Transferred".',
  ADMINISTERED: 'Administered',
  SCHEDULED_FOR: 'Scheduled for',
  SIGNED_BY: 'Signed by',
  SIGNED_AT: 'Signed at',
  OUTCOME: 'Outcome',
  STOCK_UPDATED: 'Stock updated',
  REMOVED_FROM_STOCK: 'removed from stock',
  LEFT: 'left',
  NOT_APPLICABLE: 'Not applicable',
  PRN: 'PRN',
  COMMENT: 'Comment',
  PREVIOUS_EXPECTED_STOCK: 'Previous Expected Stock',
  ACTIVE: 'Active',
  DISCONTINUED: 'Discontinued',
  SCHEDULED: 'Scheduled',
  NOT_SCHEDULED_PRN: 'Not Scheduled (PRN)',
  WAITING_FOR_DISPOSAL: 'Waiting for disposal',
  NO_STOCK_LEFT: 'No stock left',
  ADD_MEDICATION: 'Add Medication',
  RESIDENT_MEDICATION_STOCK: "{{residentName}}'s Medication Stock",
  STOCK_LEVEL_LOW: 'Stock level low',
  STOCK_LEVEL_OK: 'Stock level ok',
  OUT_OF_STOCK: 'Out of stock',
  UPDATED: 'Updated',
  NO_ACTIVE_MEDICATIONS_TITLE: '{{name}} has no active medications at the moment',
  NO_ACTIVE_MEDICATIONS_SUBTITLE: 'Learn more about adding a medication',
  NO_DISCONTINUED_MEDICATIONS_TITLE: '{{name}} has no discontinued medications yet',
  NO_DISCONTINUED_MEDICATIONS_SUBTITLE: 'Only medications discontinued from {{date}} is visible here.',
  HERE: 'here'
}

export const emarV2Constants = getKeys(
  emarV2Translations as Record<string, any>
)
